import VolumeTable from './VolumeTable';

export default VolumeTable;
